import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
 expensesTypeState,
 expensesTypesSlice
} from './ExpensesTypeSlicer';
import { addExpenseTypeSlice } from './AddModal/AddModalSlice';

// API
import  { expensesType_response, sortDirectionType } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import AddModal from './AddModal/AddModal';

import { Confirm } from '../../components/Alerts/Alerts';
import { havePermission } from '../../services/hoc/permissions';
import { useLocation } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { getListSort } from '../../services/hoc/sort';
import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';
import { useAPI } from '../../services/hoc/useAPI';
import { AxiosError } from 'axios';
import { useNotification } from '../../services/usenotification';

const ExpensesType =() => {
  // Translation
  const t = useTranslation();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  // Redux
  const dispatch = useDispatch();
  const location = useLocation();
  const {alertError500}=useNotification()
  const [showModal,setShowModal]=useState({open:false,id:0})
  const keyword_ref = useRef<string|null>(null)
  const state = useSelector(
    (state: { expenses_type: expensesTypeState }) =>
      state.expenses_type,
  );


const ENDPOINTS = useAPI()
  // Search
  const search = (value: string) => {

    dispatch(expensesTypesSlice.actions.reset());
    keyword_ref.current=Boolean(value)?value:null

    fetchData(1,Boolean(value)? 20:8, value);
  };

  // Fetch Data
  const fetchData = (
    page: number,
    page_size: number = 10,
    keyword: string = '',
    sort_direction?:sortDirectionType,
    sort_field?:number

  ) => {
    
    dispatch(expensesTypesSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.expensesType()
      .index({ page, page_size, keyword ,sort_direction:sort_direction,sort_field :sort_field})
      .then((response) => {
        dispatch(expensesTypesSlice.actions.setIsFetching(false));
        dispatch(expensesTypesSlice.actions.setPage(pagesInfo.page));
        // if (response.data.data.last_page)
        //   setPagesInfo((pre) => ({
        //     ...pre,
        //     lastPage: response.data.data.last_page,
        //   }));
        let expensesTypes: expensesType_response[] = response.data.data.expensetypes.map(
          (expensestype): expensesType_response => expensestype,
        );
      
        dispatch(
          expensesTypesSlice.actions.init(expensesTypes),
        );
      

        if (!state.isLoaded)
          dispatch(expensesTypesSlice.actions.setIsLoaded(true));
      })
      .catch((err:AxiosError)=> {
         dispatch(expensesTypesSlice.actions.setIsFetching(false));
         alertError500(err)
         
      })
  }

  const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
    
     
      //setSortOptions(pre=>({...pre,sort_direction,sort_field}))
      fetchData(state.page,8,'',sort_direction,sort_field)
    }
  },[state.page])


  
  const actions =(expenses:expensesType_response)=>(
    <div className="show-on-hover">
      {havePermission('Show Expense Type') ? (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              // dispatch( showReciptVoucherSlice.actions.setIsOpen({ id: receiptVoucher.id, isOpen: true }) )
              setShowModal(pre=>({...pre ,open:true,id:  expenses.id??-1}))
              // dispatch(
              //   addReceiptVoucherSlice.actions.setIsOpen(true),
              // );
              dispatch(
                addExpenseTypeSlice.actions.setIsLoading(true),
              );
              dispatch(
                addExpenseTypeSlice.actions.setEditId(
                  expenses.id??-1,
                ),
              );
              ENDPOINTS.expensesType()
                .show({ id: expenses.id??-1 })
                .then((response) => {
                  dispatch(
                    addExpenseTypeSlice.actions.set({
                      
                        code:response.data.data.code??'',
                        name:response.data.data.expense??''

                      }
                      ),
                    )
                    })
                  
                  dispatch(
                    addExpenseTypeSlice.actions.setIsLoading(
                      false,
                    ),
                  );
                }}
            
          />
        </Tooltip>
      ) : (
        ''
      )}
      {/* havePermission("Edit Receipt Voucher") ?
                  <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                      e.stopPropagation()
                      dispatch( addReceiptVoucherSlice.actions.setIsOpen(true) )
                      dispatch( addReceiptVoucherSlice.actions.setIsLoading(true) )
                      dispatch( addReceiptVoucherSlice.actions.setEditId(receiptVoucher.id) )
                      ENDPOINTS.receipt_vouchers().show({ id: receiptVoucher.id })
                      .then((response: any) => {
                          dispatch( addReceiptVoucherSlice.actions.set({
                              ...response.data.data,
                              client_name: response.data.data.client?.name,
                              order_no: response.data.data.order?.order_no,
                              date: response.data.data.date.replace(/\//g, "-")
                          }) )
                          dispatch( addReceiptVoucherSlice.actions.setIsLoading(false) )
                      })
                  } } /> : "" */}
      {havePermission('Delete Expense Type') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(expenses.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  )
  const rows =()=>{
    return (
      state.expensesType[state.page]
      ? state.expensesType[state.page].map((ex, index) => {
        return (
          <RowContainer 
          key={ex.id}
          item_id={(ex.id??'-1').toString()}
          onSelect={toggleSelectedId}
          state_length={state.expensesType[state.page].length}
          tr_index={index}
          columns={[
            ex.expense,
            ex.code,
            actions(ex)
          ]}
          />
        )
      }):null
    )
    }

  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const toggleSelectedId = (id: string) => {
    if (!havePermission('Delete Expense Type')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(expensesTypesSlice.actions.setIsLoading(true));
    ENDPOINTS.expensesType()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(expensesTypesSlice.actions.setIsLoading(false));
        dispatch(expensesTypesSlice.actions.deleteExpensesType(ids));
      })
      .catch((err:AxiosError)=>{
        alertError500(err)
          dispatch(expensesTypesSlice.actions.setIsLoading(false));
      })
  };

  // First fetch
  useEffect(() => {
    if (location.state) {
      if (!state.isFetching) {
       search(location.state.key)
      }
    } else {
      if (!state.isLoaded && !state.isFetching) {
        fetchData(1);
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
  
      if (!state.isFetching) {
        expensesTypesSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page);
      }
    }
  }, [pagesInfo.page]);

//console.log('state',state)
  
  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <TableActionBar
            title={t('expenses_type')}
            keyword={location.state ? location.state.key : ''}
            search={search}
            showFilter={false}
            showDelete={selectedIds.length > 0}
            delete={() => {
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(),
              });
            }}
            addText={t('add_expenses_type')}
            add={havePermission('Add Expense Type')?
               () =>   setShowModal(pre=>({...pre ,open:true,id:  0}))
               : undefined
                
            }
          />

     
          <SortTable
            header={[
              t('expense'),
              t('code'),
              '',
            ]}
           state={state.expensesType[state.page]??[]}
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={fetchData}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            sort_fields={getListSort(['expense','code'
            ,''],'Expense_Type')}
            fetchSortedData={fetchSortedData}
           >
            <>
            {
              rows()
            }
            </>

          </SortTable>

{showModal && <AddModal showModal={showModal.open} id={showModal.id}
             closeModal={()=>setShowModal(pre=>({...pre ,open:false}))} />}

      
          
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default ExpensesType ;
